

export default {
    name: 'stars',
    props: {
        count: {
            type: Number,
            required: false,
            default: 5
        }
    },
    components: {
    },
    created() {
        let t = this;
    },
    activated() {
        let t = this;
    },
    methods: {
    },
    data() {
        return {
        };
    },
    computed: {
    }
};
